export default __webpack_public_path__ + "static/media/checkresult.a8a4c461.png";